import RequestForm from "../../../../core/model2/form/request-form"
import DatetimeUtils from "../../../../core/gd/utils/datetime-utils"
import {prepareSubmissionData} from "./prepare-submission-data"
import {MandatoryFieldsIds} from "../@const"

// const debug = "prepareFormDataForSubmission"
const debug = false

export default function prepareFormDataForSubmission(requestForm:RequestForm, result:any) {

    debug && console.log(debug, 'process', requestForm, result)

    const submissionData: any = {
        requestFormId       : requestForm.id
    }

    const formFields:any    = []
    let fromName            = ''
    let fromEmail           = ''

    const nameFieldId = requestForm.settings.nameField?.field?.fieldId
    if (nameFieldId) fromName = result[nameFieldId]

    const emailFieldId = requestForm.settings.emailField?.field?.fieldId
    if (emailFieldId) fromEmail = result[emailFieldId]

    const assignedToUserId = result.assignedToUserId ? result.assignedToUserId : requestForm.assignToUserId
    if (assignedToUserId) {
        submissionData.user = assignedToUserId
    }

    // REQUIRED TITLE FIELD
    submissionData.title = result[MandatoryFieldsIds.TITLE]

    debug && console.log(debug, 'process fields', requestForm.settings.fields)

    prepareSubmissionData(requestForm, submissionData, formFields, result)

    //hotfix (otherwise message 'scheduleDate: "unconverted data remains: T21:00:00.000Z"' is received
    if (submissionData.scheduleDate) {
        submissionData.scheduleDate = DatetimeUtils.momentToDate(DatetimeUtils.datetimeToMoment(submissionData.scheduleDate))
    }

    submissionData.source = {
        type            : 'request-form',
        requestFormName : requestForm.name,
        formFields      : formFields
    }

    if (fromName)   submissionData.source.fromName  = fromName
    if (fromEmail)  submissionData.source.fromEmail = fromEmail

    debug && console.log("    submissionData=", submissionData)

    return submissionData
}